// extracted by mini-css-extract-plugin
module.exports = {"root":"_28512c","title":"_7b6239","iconInfo":"_4c1b48","carouselContainer":"_79c277","contenderCards":"_e5a871","pagination":"_bd56f7"};